import { Plans } from "schemas/payments";

import ProPlanCard from "../Plan/PlanCard/Pro";
import VirtualAssistantPlanCard from "../Plan/PlanCard/VirtualAssistant";

const OnboardingPaywallMobile = () => {
  return (
    <>
      <ProPlanCard plan={Plans.PRO_YEARLY} />
      <VirtualAssistantPlanCard plan={Plans.VA_YEARLY} />
    </>
  );
};

export default OnboardingPaywallMobile;
